export type FontSize = 'small' | 'default' | 'large' | 'extra-large';

export const fontSizeScales: Record<FontSize, number> = {
  small: 0.875, // 87.5% - 14px base
  default: 1, // 100%  - 16px base
  large: 1.125, // 112.5% - 18px base
  'extra-large': 1.25, // 125%  - 20px base
};

export const fontSizeLabels: Record<FontSize, string> = {
  small: 'Small',
  default: 'Default',
  large: 'Large',
  'extra-large': 'Extra Large',
};

export const getInitialFontSize = (): FontSize => {
  const stored = localStorage.getItem('fontSize');
  if (stored && stored in fontSizeScales) {
    return stored as FontSize;
  }
  return 'default';
};

export const setFontSize = (size: FontSize) => {
  localStorage.setItem('fontSize', size);
  const scale = fontSizeScales[size];
  const percentage = Math.round(scale * 100);

  // Set CSS variable for browsers that support it (Chrome, Firefox, desktop Safari)
  document.documentElement.style.setProperty('--font-size-scale', scale.toString());

  // Use -webkit-text-size-adjust for iOS/Android WebView compatibility
  // This works on mobile WebViews where CSS variable font-size may not work
  document.body.style.setProperty('-webkit-text-size-adjust', `${percentage}%`);
};

export const initializeFontSize = () => {
  setFontSize(getInitialFontSize());
};
